import { Route, Routes } from "react-router-dom";
import "./App.css";
import {
  Login,
  OtpForm,
  //SignUp,
  CreatePassword,
  ForgotPassword,
  ResetPassword,
} from "pages/AuthPages";
import Notfound from "pages/Notfound";
import Playground from "pages/Playground";
import {
  Configurations,
  Dashboard,
  Institutions,
  SubAdmins,
  Transactions,
  CreditHistory,
} from "pages/DashboardPages";
import BalanceConfiguration from "pages/DashboardPages/BalanceConfiguration";
import { Toaster } from "react-hot-toast";
import { userData } from "utils/userData";
import AuditTrail from "pages/DashboardPages/AuditTrail";
import TransactionPerformanceMetric from "pages/DashboardPages/Metrics/TransactionPerformance";
import InstitutionPerformanceMetric from "pages/DashboardPages/Metrics/InstitutionPerformance";
import TransactionReportMetric from "pages/DashboardPages/Metrics/TransactionReport";
import TodaysTransactionMetric from "pages/DashboardPages/Metrics/TodaysTransactionMetric";
import ApprovalRate from "pages/DashboardPages/Metrics/ApprovalRate";
import ResponseTime from "pages/DashboardPages/Metrics/ResponseTime";
import Download from "pages/download";
import TransactionsDb from "pages/DashboardPages/TransactionsDb";
import InstitutionDetailsPage from "pages/DashboardPages/InstitutionDetailsPage";

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          success: {
            style: {
              fontSize: "16px",
              marginTop: "14px",
              color: "white",
              background: "#3fb172",
              padding: "10px",
            },
          },
          error: {
            style: {
              fontSize: "16px",
              marginTop: "14px",
              color: "white",
              background: "#ff0000",
              padding: "10px",
            },
          },
        }}
      />
      <Routes>
        {/* OTP PAGES */}
        <Route path="/" element={<Login />} />
        {/* <Route path="/" element={<SignUp />} /> */}
        <Route path="/otp" element={<OtpForm />} />
        <Route path="/createpassword" element={<CreatePassword />} />
        <Route path="/send-mail" element={<ForgotPassword />} />
        <Route path="/forgot-password" element={<ResetPassword />} />
        {/* OTP PAGES */}

        {/* DASHBOARD PAGES */}
        <Route path="/dashboard" element={<Dashboard />} />
        {/* METRIC PAGES */}

        <Route path="/response-time" element={<ResponseTime />} />
        <Route path="/approval-rate" element={<ApprovalRate />} />
        <Route
          path="/transaction-report"
          element={<TransactionReportMetric />}
        />
        <Route
          path="/institution-performance"
          element={<InstitutionPerformanceMetric />}
        />
        <Route
          path="/transaction-performance"
          element={<TransactionPerformanceMetric />}
        />
        <Route
          path="/today-transaction"
          element={<TodaysTransactionMetric />}
        />
        <Route path="/download" element={<Download />} />
        {userData?.userDetail?.role === "chiefAdmin" && (
          <Route path="/sub-admins" element={<SubAdmins />} />
        )}
        {userData?.userDetail?.role === "subAdmin1" && (
          <Route path="/sub-admins" element={<SubAdmins />} />
        )}
        {userData?.userDetail?.role === "subAdmin2" && (
          <Route path="/sub-admins" element={<SubAdmins />} />
        )}
        {userData?.userDetail?.role === "bankAdmin" && (
          <Route path="/bank-user" element={<SubAdmins />} />
        )}
        {userData?.userDetail?.role === "nonBankAdmin" && (
          <Route path="/non-bank-user" element={<SubAdmins />} />
        )}
        {userData?.userDetail?.role === "chiefAdmin" && (
          <Route path="/audit-trail" element={<AuditTrail />} />
        )}
        {userData?.userDetail?.role === "chiefAdmin" && (
          <Route path="/configurations" element={<Configurations />} />
        )}
        {userData?.userDetail?.role === "chiefAdmin" && (
          <Route
            path="/balance-configuration"
            element={<BalanceConfiguration />}
          />
        )}
        <Route path="/institutions" element={<Institutions />} />
        <Route
          path="/institution-details"
          element={<InstitutionDetailsPage />}
        />
        <Route
          path="/institution-credit-history"
          element={<CreditHistory />}
        />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/transactions-db" element={<TransactionsDb />} />
        {/* DASHBOARD PAGES */}
        <Route path="*" element={<Notfound />} />
        <Route path="/playground" element={<Playground />} />
      </Routes>
    </>
  );
}

export default App;
